export default __webpack_public_path__ + "static/mobile-welfare-a0dce3120f4ff1267cbd425e2917f358.jpg";